module.exports = global.config = {
  host: "https://api-gateway.sampangkab.go.id/be-jdih",
  document_api: "https://jdih.sampangkab.go.id/panel",
  // document_api: "http://p-jdih.test",
  subdomain: "",
  // subdomain: "jdih",
};
